import React, { ReactNode } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import styled from "@emotion/styled";

export const Block = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(2),
}));

export const Content = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 4, 2),
}));

const Accordion = styled(MuiAccordion)(() => ({
  border: 0,
  boxShadow: "none",

  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
  padding: theme.spacing(0),

  "& .MuiAccordionSummary-content": {
    margin: 0,
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(() => ({
  padding: 0,
}));

interface Props {
  id: string;
  summary: ReactNode;
  expandIconTestId: string;
  children: ReactNode;
}

export const InfoAccordion = ({
  id,
  summary,
  expandIconTestId,
  children,
}: Props) => (
  <Accordion
    elevation={0}
    square
    sx={{
      ".MuiAccordionSummary-root": {
        minHeight: "0!important",
      },
      ".MuiAccordionSummary-content": {
        margin: "0!important",
      },
    }}
  >
    <AccordionSummary
      expandIcon={<ExpandMoreIcon data-testid={expandIconTestId} />}
      aria-controls={`${id}-content`}
      sx={{
        margin: 0,
      }}
    >
      {summary}
    </AccordionSummary>
    <AccordionDetails>{children}</AccordionDetails>
  </Accordion>
);
